import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './StepProgress.module.scss'

type StepProgressProps = {
  label?: string
  size?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  isActive?: boolean
  isDisabled?: boolean
  isDone?: boolean
  isEdited?: boolean
}

export const StepProgress = React.forwardRef<HTMLElement, StepProgressProps>(
  ({ label, size, onClick, isActive, isDisabled, isDone, isEdited }, ref) => {
    const value = isDone ? 100 : isActive ? 0 : 0

    return (
      <Box
        align="center"
        ariaRole="presentation"
        className={cx(
          styles.progress,
          {
            [styles.active]: isActive,
            [styles.disabled]: isDisabled,
            [styles.done]: isDone,
            [styles.edited]: isEdited,
            [styles.size]: Boolean(size),
          },
          size && styles[size],
        )}
        direction="column"
        justify="center"
        ref={isActive ? ref : null}
      >
        {label != null ? (
          <button
            className={styles.button}
            disabled={isDisabled}
            {...{ onClick }}
          >
            <Box align="center" justify="center" tagName="span">
              {label}
            </Box>
          </button>
        ) : null}
        <progress className={styles.bar} id={label} max={100} {...{ value }} />
      </Box>
    )
  },
)
